// AxiosInstance.js
import axios from "axios";

const AxiosInstance = axios.create({
  baseURL:
    // "http://localhost:8080/",
    "https://api.florenceht.com/",
  headers: {
    "Content-Type": "application/json",
  },
});

// Add interceptor to include Bearer token
AxiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default AxiosInstance;
